import LoginView from '@/views/session/login-view.vue'
import ChangePassword from '@/views/session/change-password.vue'
import ProfileView from '@/views/session/profile.vue'
import { SessionRouteNames } from '@/router/routes-names'

export const sessionRoutes = [
    {
        path: '/login',
        name: SessionRouteNames.LOGIN,
        component: LoginView
    },
    {
        path: '/me/profile',
        name: SessionRouteNames.PROFILE,
        component: ProfileView
    },
    {
        path: '/me/change-password',
        name: SessionRouteNames.CHANGE_PASSWORD,
        component: ChangePassword
    }
]
